import gql from 'graphql-tag';
import { query } from '../../client';
export const PROFILE_CHECK = gql `
  query CheckProfileQuery($accountId: String!) {
    profileCheck(accountId: $accountId)
      @rest(type: "ProfileCheckResult", path: "internal/users/check?accountid={args.accountId}") {
        data {
          status
          email
          metadata
        }
      }
  }
`;
export function checkProfile(accountId) {
    return query({
        query: PROFILE_CHECK,
        variables: { accountId },
        fetchPolicy: 'network-only'
    });
}
export default checkProfile;
